class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onToggle() {
      if (!this.animations) this.animations = this.content.getAnimations();

      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animations.forEach((animation) => animation.play());
      } else {
        this.animations.forEach((animation) => animation.cancel());
      }
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  customElements.define('details-disclosure', DetailsDisclosure);

  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.header-wrapper');
      this.isDesktop = window.matchMedia('(min-width: 990px)');
      this.hoverTimeout = null;

      // Add hover event listeners for desktop
      if (this.isDesktop.matches) {
        this.addHoverListeners();
      }

      // Listen for media query changes
      this.isDesktop.addEventListener('change', (e) => {
        if (e.matches) {
          this.addHoverListeners();
        } else {
          this.removeHoverListeners();
        }
      });
    }

    onToggle() {
      if (!this.header) return;
      this.header.preventHide = this.mainDetailsToggle.open;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    addHoverListeners() {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    removeHoverListeners() {
      this.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.removeEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    onMouseEnter() {
      if (!this.isDesktop.matches) return;

      clearTimeout(this.hoverTimeout);
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
        this.onToggle();
      }
    }

    onMouseLeave() {
      if (!this.isDesktop.matches) return;

      this.hoverTimeout = setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.close();
        }
      }, 150);
    }
  }

  customElements.define('header-menu', HeaderMenu);
